import EventEmitter from "events";

export default class BaseAsr extends EventEmitter {

  start() {
    throw new Error('未實現start()');
  }

  stop() {
    throw new Error('未實現stop()');
  }
}
